import { api } from '@shared/services/api';
import { url } from 'constants/urls';
import { UserDetails } from '../../interface/userDetails';

export const getUserDetails = async () => {
  const { data } = await api.get<UserDetails>(url.userDetails);

  return data;
};
